module.exports = __webpack_public_path__ + "img/halimah.f87d97dc.jpeg";